import React from 'react';
import { makeStyles, Typography } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
  root: {
    maxWidth: theme.spacing(70),
    margin: 'auto',
  },
  title: {
    marginBottom: theme.spacing(2),
  },
  presentation: {
    textIndent: '10%',
    textAlign: 'justify',
  },
}));

export const AboutPage = (): JSX.Element => {
  const classes = useStyles();
  return (
    <div className={classes.root}>
      <Typography variant="h5" className={classes.title}>
        About
      </Typography>
      <Typography className={classes.presentation}>
        I&apos;ve been trying to learn Czech for the last couple of years.
        Watching Czech movies has been very tedious, as I was encountering an
        overwhelming number of unknown words every minute.
      </Typography>
      <Typography className={classes.presentation}>
        There was no good tool to assist me creating (Anki) flashcard. I&apos;ve
        tried every tool I could find, but there were mostly buggy and
        abandonned projects. So I decided to make my own.
      </Typography>
      <Typography className={classes.presentation}>
        I hope it helps many other students around the world.
      </Typography>
    </div>
  );
};
